import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import PrivateRoute from './PrivateRoute';
import http from './commonFunctions/httpClient';
import DashboardLayout from './Components/Dashboard/DashboardLayout';
import config from './Config/config.json';
import { DoctorLoginForm } from './FrontEnd/Login/Login';
import Logout from './FrontEnd/Logout/LogOut';
import { UserList } from './Backend/Users/UserList';
import { UserCreate } from './Backend/Users/UserCreate';
import { UserRegistration } from './Backend/Users/UserRegistration';
import { VerifyOTP } from './Backend/Users/VerifyOtp';
import { ForgotPassword } from './Backend/Users/ForgotPassword';
const SESSION_TIMEOUT = config.sessionTimeOut * 60 * 1000; // 15 minutes

const App: React.FC = () => {
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
  const [lastActivity, setLastActivity] = useState<number>(Date.now());

  const tokenFromStorage = localStorage.getItem('token');
  if (tokenFromStorage) {
    http.setAuthToken(tokenFromStorage);
  }

  useEffect(() => {
    if (!token) return;

    const handleActivity = () => {
      setLastActivity(Date.now());
    };

    // Add event listeners for user activity
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);

    const checkTimeout = () => {
      if (Date.now() - lastActivity > SESSION_TIMEOUT) {
        handleLogout(); // Logout the user after inactivity
        window.location.reload();
      }
    };

    const intervalId = setInterval(checkTimeout, 1000); // Check for timeout every second

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
    };
  }, [lastActivity, token]);
  useEffect(() => { if (token) http.setAuthToken(token) }, [token])
  const handleLogin = (newToken: string) => {
    setToken(newToken);
    localStorage.setItem('token', newToken);
    http.setAuthToken(newToken);
  };

  const handleLogout = useCallback(() => {
    setToken(null);
    localStorage.removeItem('token');
    http.setAuthToken(null);
  }, []);

  return (
    <Router>
      <CssBaseline />
      <Routes>
        <Route path="/" element={token ? <DashboardLayout /> : <Navigate to="/login" replace />}>
          <Route index element={token ? <UserList /> : <Navigate to="/login" />} />
          <Route path="/*" element={<PrivateRoute token={token} />} />
        </Route>
        <Route path="/login" element={token ? <Navigate to="/" /> : <DoctorLoginForm onLogin={handleLogin} />} />
        <Route path="/logout" element={<Logout />} />
        {/* <Route path='/doctor/login' element={<DoctorLoginForm  onLogin={handleLogin}/>} /> */}
        {/* Wrap all routes in AdminLayout */}
        <Route path="/" element={<DashboardLayout />}>

          <Route path="/*" element={<PrivateRoute token={token} />} />
        </Route>
        <Route path="/register" element={<UserRegistration />} />
        <Route path="/verifyOtp" element={<VerifyOTP />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />


      </Routes>

    </Router>
  );
};

export default App;